<template>
  <v-navigation-drawer id="app-drawer" v-model="inputValue" app dark floating persistent mobile-break-point="991"
    width="250">
    <v-layout class="fill-height" tag="v-list" column>

      <v-list-tile class='pb-2' style="padding-top:30px">
        <img src='/img/logo_emn_trial_office.svg' />
      </v-list-tile>

      <v-list-tile style="text-align:center">
        <div style="width:100%;text-align:right;padding-top:10px">
          <h4 style="font-size:0.8em !important;letter-spacing: 7px !important;color: orange;font-weight: 400 !important;">SAFETY DATABASE</h4>
        </div>
      </v-list-tile>

      <v-divider />

      <v-list-tile v-if="responsive">
        <v-text-field class="purple-input search-input" label="Search..." color="purple" />
      </v-list-tile>

      <component v-for="(link, i) in links" :is="link.type" :key="i" v-bind="link.props" avatar>
      </component>

    </v-layout>

  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    responsive: true
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    },
    sidebarOverlayGradiant() {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor
        }`;
    },
    links() {

      const el = this.$store.getters.sponsors.filter(el => el.id == this.$store.getters.sponsor_id);
      let badge
      if (!el.length) {
        badge = {
          ae_unread: null,
          pregnancy_unread: null,
          spm_unread: null,
          mm_query: null
        }
      } else {
        badge = el[0];
      }

      var links = [
        {
          type: "core-drawer-link",
          props: {
            to: "/dashboard",
            text: "Dashboard",
            entity: 'dashboard',
            icon: "mdi-view-dashboard",
            badge: null
          }
        },
        {
          type: "core-drawer-group",
          props: {
            text: "Settings",
            links: [
              {
                to: "/accounts",
                icon: "mdi-account",
                text: "Accounts",
                entity: 'account',
                badge: null
              },
              {
                to: "/protocol",
                icon: "mdi-clipboard-text",
                text: "Protocols",
                entity: 'protocol',
                badge: null
              },
              {
                to: "/site",
                icon: "mdi-hospital-building",
                text: "Sites",
                entity: 'site',
                badge: null
              },
              {
                to: "/protocol_site",
                icon: "mdi-clipboard-list",
                text: "Protocol Sites",
                entity: 'protocol_site',
                badge: null
              },
              {
                to: "/external_user",
                icon: "mdi-doctor",
                text: "External Users",
                entity: 'external_user',
                badge: null
              }
            ]
          }
        },
        {
          type: "core-drawer-group",
          props: {
            text: "Companies",
            links: [
              {
                to: "/companies",
                icon: "mdi-office-building",
                text: "Companies",
                entity: 'company',
                badge: null
              },
              {
                to: "/company_protocols",
                icon: "mdi-domain",
                text: "Company Protocols",
                entity: 'company_has_protocols',
                badge: null
              },
              {
                to: "/company_users",
                icon: "mdi-account-tie",
                text: "Company Users",
                entity: 'company_user',
                badge: null
              }
            ]
          }
        },
        {
          type: "core-drawer-link",
          props: {
            to: "/treatment",
            icon: "mdi-pill",
            text: "Treatments",
            entity: 'treatment',
            badge: null
          }
        },
        {
          type: "core-drawer-link",
          id: 'ae',
          props: {
            to: "/adverse_events",
            icon: "mdi-account-alert",
            text: "Adverse Events",
            entity: 'adverse_event',
            badge: badge.ae_unread
          }
        },
        {
          type: "core-drawer-link",
          id: 'pregnancy',
          props: {
            to: "/pregnancies",
            icon: "mdi-human-pregnant",
            text: "Pregnancy",
            entity: 'pregnancy',
            badge: badge.pregnancy_unread
          }
        },
        {
          type: "core-drawer-link",
          id: 'spm',
          props: {
            to: "/spms",
            icon: "mdi-numeric-2-box-multiple-outline",
            text: "SPM",
            entity: 'spm',
            badge: badge.spm_unread
          }
        },
        {
          type: "core-drawer-link",
          props: {
            to: "/metrics",
            icon: "mdi-chart-bar",
            text: "Metrics",
            entity: 'metrics',
            badge: null
          }
        },

        {
          type: "core-drawer-link",
          props: {
            to: "/reports",
            icon: "mdi-file-excel",
            text: "Reports",
            entity: 'reports',
            badge: null
          }
        },

        {
          type: "core-drawer-link",
          props: {
            to: "/mm_query",
            icon: "mdi-account-question",
            text: "MM Query",
            entity: 'mm_query',
            badge: badge.mm_query
          }
        },
      ]

      // acl
      links.forEach((el, index, arr) => {
        if (el.type == 'core-drawer-group') {
          var hide = false

          const sublinks = el.props.links.filter(subel => {
            return this.$can('read', subel.entity || 'all')
          })

          if (!sublinks.length) {
            hide = true
          }
          el.props.links = sublinks
          el.hide = hide
          arr[index] = el
        }
      })


      links = links.filter(el => {
        return (el.type == 'core-drawer-group' && !el.hide) || (el.type == 'core-drawer-link' && this.$can('read', el.props.entity || 'all'))
      })

      return links
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }

  div.v-responsive.v-image>div.v-responsive__content {
    overflow-y: auto;
  }
}
</style>
